import React from "react";
import { slide as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";

import "./HamMenu.scss";

const HamMenu = (props) => {
  return (
    // Pass on our props
    <Menu {...props}>
      <Link to="/">Home</Link>

      <a className="menu-item" href="/burgers">
        Coming Soon
      </a>

      <a className="menu-item" href="/pizzas">
        Trending
      </a>

      <a className="menu-item" href="/desserts">
        Media
      </a>
      <a className="menu-item" href="/desserts">
        Settings
      </a>
    </Menu>
  );
};
export default HamMenu;
